mutation upgradeToBasic($input: UpgradeToBasicInput!) {
  upgradeToBasic(input: $input)
}
